import React from 'react';
import { useLocation } from "@reach/router"
import { defaultFacets, normalizeItems, sortOptions } from '../../config/search';
import Search from "../../components/Medata/search/civil/components/Search";
import SearchSidebar from "../../components/Medata/search/civil/templates/SearchSidebar";
import SearchContent from "../../components/Medata/search/civil/templates/SearchContent";
import Breadcrumb from '../../components/Medata/breadcrumb';
import Layout from "../../components/Layout";

const SearchTemplate = ({ path }) => {
  const location = useLocation();
  const [themes, setThemes] = React.useState([]);
  React.useEffect(() => {
    // Extraemos el tema con URLSearchParams para no arrastrar otros parámetros
    // (p. ej. distribution__item__format del filtro de formato). Antes se cortaba
    // la URL "a mano" desde 'theme=' hasta el final, así que con una URL como
    // ?theme=Cultura&distribution__item__format=json el título quedaba como
    // "Cultura&distribution__item__format=json". URLSearchParams corta en '&' y
    // toma solo el primer valor del tema.
    if (typeof window === 'undefined') {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    // URLSearchParams.get ya devuelve el valor decodificado, así que no
    // re-aplicamos decodeURIComponent (rompería con valores que tengan '%').
    const themeParam = params.get('theme');
    if (themeParam) {
      const theme = themeParam.split(',')[0];
      setThemes([{ identifies: theme, data: theme }]);
    }
  }, []);

  return (
    <Layout title="Resultados" headerClass='header header--small'>
      {themes && Array.isArray(themes) && <Breadcrumb themes={themes} curretItem={{}} />}
      <Search
        searchEndpoint={`/api/search-fast`}
        defaultFacets={defaultFacets}
        sortOptions={sortOptions}
        setSearchUrl={true}
        path={path}
        location={location}
        normalize={normalizeItems}
      >
        <div className="container movility">
          <SearchSidebar
            title={themes && Array.isArray(themes) && themes.length > 0 ? themes[0].data : ''}
            withIcon={themes && Array.isArray(themes) && themes.length > 0 ? true : false}
          />
          <SearchContent sortOptions={sortOptions} />
        </div>
      </Search>
    </Layout>
  );
}

export default SearchTemplate;
